import { LayoutRow } from "./LayoutRow";

export * from "./LayoutRow";
export * from "./LayoutBlock";



export class LayoutEditForm {
    public Rows: LayoutRow[];
    public CategoriesEnabled: boolean = true;
    public ParticipantEnabled: boolean = true;
    public DiscussionSendMessEnabled: boolean = true;
    public DocumentUploadEnabled: boolean = true;
    public EmailAttachmentListEnabled: boolean = true;    
    public Enabled: boolean = false;
    public Settings: Object;
}

